import * as tslib_1 from "tslib";
import { Component, Prop, Inject } from "vue-property-decorator";
import { H3RadioList, H3CheckboxList } from 'h3-mobile-vue';
import ControlBack from '@cloudpivot/form/src/common/directives/control-back';
import { CheckboxGroupControl } from "@cloudpivot/form/src/common/controls/checkbox-group-control";
let CheckboxGroup = class CheckboxGroup extends CheckboxGroupControl {
    constructor() {
        super(...arguments);
        this.showModal = false;
        this.tampValue = '';
    }
    show() {
        this.showModal = true;
        this.tampValue = this.ctrl.value;
    }
    close() {
        this.showModal = false;
        this.ctrl.value = this.tampValue;
    }
    //上下布局模式
    get layoutType() {
        if (this.layoutTypeFn) {
            return this.layoutTypeFn();
        }
    }
    get checkBoxTitle() {
        if (this.isSheetTable) {
            return '';
        }
        else {
            return this.label;
        }
    }
    clear() {
        //单选按钮点击请选择、清空按钮后清空值
        this.tampValue = '';
    }
    onChange(val) {
        if (val) {
            if (this.isRadio) {
                this.tampValue = typeof val === 'string' ? val : val.value;
            }
            else {
                this.tampValue = val.slice();
                this.ctrl.value = val.slice();
            }
        }
        else {
            this.tampValue = '';
        }
    }
};
tslib_1.__decorate([
    Prop({ default: false })
], CheckboxGroup.prototype, "isSheetTable", void 0);
tslib_1.__decorate([
    Inject()
], CheckboxGroup.prototype, "layoutTypeFn", void 0);
CheckboxGroup = tslib_1.__decorate([
    Component({
        name: "checkbox-group",
        components: {
            H3RadioList,
            H3CheckboxList
        },
        directives: {
            ControlBack,
        },
    })
], CheckboxGroup);
export default CheckboxGroup;
